import { render, staticRenderFns } from "./RelativeInvoice.vue?vue&type=template&id=7f525e9f&scoped=true"
import script from "./RelativeInvoice.vue?vue&type=script&lang=js"
export * from "./RelativeInvoice.vue?vue&type=script&lang=js"
import style0 from "./RelativeInvoice.vue?vue&type=style&index=0&id=7f525e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f525e9f",
  null
  
)

export default component.exports